import { Component, input, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';

import { CheckboxComponentModule, SimpleInputModule, TextAreaComponentModule } from '@hglobal/fin-ui';
import { FormGroup } from '@ngneat/reactive-forms';
import { GroupResolverFormBuilder } from '@ngneat/reactive-forms/lib/form-builder';
import { TranslateModule } from '@ngx-translate/core';

import { ExchangeFormSepaSwiftModel } from '@kr/components/exchange/models/exchange-form-sepa-swift.model';

export const pattern = /^[A-Za-z0-9/-?:().,'+ ]+$/;
const bicRegex = /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
const ibanRegex = /^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/;
const alphanumericRegex = /^[A-Za-z0-9]+$/;
const maxLengthIncorporateNum = 35;
const maxLengthBeneficiaryName = 50;
const maxLengthCorrespondentBankName = 105;

@Component({
  selector: 'kr-exchange-set-crypto-fiat-iban',
  imports: [ReactiveFormsModule, SimpleInputModule, TranslateModule, TextAreaComponentModule, CheckboxComponentModule],
  templateUrl: './exchange-set-crypto-fiat-iban.component.html',
  styleUrl: './exchange-set-crypto-fiat-iban.component.scss',
})
export class ExchangeSetCryptoFiatIbanComponent implements OnInit, OnDestroy {
  form = input<FormGroup<GroupResolverFormBuilder<ExchangeFormSepaSwiftModel>>>();

  ngOnInit(): void {
    this.form().controls.iban.addValidators([Validators.pattern(ibanRegex), Validators.required]);
    this.form().controls.BICOrSWIFTCode.addValidators([Validators.pattern(bicRegex), Validators.required]);
    this.form().controls.reference.addValidators([Validators.pattern(pattern)]);
    this.form().controls.beneficiaryName.addValidators([
      Validators.maxLength(maxLengthBeneficiaryName),
      Validators.pattern(pattern),
      Validators.required,
    ]);
    this.form().controls.beneficiaryAddress.addValidators([Validators.pattern(pattern), Validators.required]);
    this.form().controls.incorporateNum.addValidators([
      Validators.pattern(alphanumericRegex),
      Validators.maxLength(maxLengthIncorporateNum),
      Validators.required,
    ]);

    if (this.form().value.transferType === 'swift') {
      this.form().controls.correspondentBankBICOrSWIFTCode.addValidators([Validators.pattern(bicRegex), Validators.required]);
      this.form().controls.correspondentBankName.addValidators([
        Validators.pattern(pattern),
        Validators.maxLength(maxLengthCorrespondentBankName),
        Validators.required,
      ]);
      this.form().controls.correspondentBankAddress.addValidators([Validators.pattern(pattern), Validators.required]);
      this.form().controls.beneficiaryBankName.addValidators([Validators.pattern(pattern), Validators.required]);
      this.form().controls.beneficiaryBankAddress.addValidators([Validators.pattern(pattern), Validators.required]);
    }
  }

  ngOnDestroy(): void {
    this.form().controls.iban.clearValidators();
    this.form().controls.BICOrSWIFTCode.clearValidators();
    this.form().controls.reference.clearValidators();
    this.form().controls.beneficiaryName.clearValidators();
    this.form().controls.beneficiaryAddress.clearValidators();
    this.form().controls.incorporateNum.clearValidators();

    if (this.form().value.transferType === 'swift') {
      this.form().controls.correspondentBankBICOrSWIFTCode.clearValidators();
      this.form().controls.correspondentBankName.clearValidators();
      this.form().controls.correspondentBankAddress.clearValidators();
      this.form().controls.beneficiaryBankName.clearValidators();
      this.form().controls.beneficiaryBankAddress.clearValidators();
    }
  }
}
